import { useTranslator } from '@translator-app/react';
import { useRouter } from 'next/router';
import React from 'react';

import { useApplicationState } from '../../contexts/application-state-context';
import { OrderStatusEnumType } from '../../generated/graphql';

export const OrderHint: React.FC = () => {
  let { order, organisation } = useApplicationState();
  let router = useRouter();
  let { translate } = useTranslator();

  if (order?.status !== OrderStatusEnumType.Created) {
    return null;
  } else {
    return (
      <div className="max-w-screen-xl mx-auto py-4">
        <div className="px-8">
          <a
            href={`/${router.locale}/${organisation.pathname}/${order.shopId}/order/overview`}
            className="block w-full px-2 py-2 rounded border bg-brand-600 text-white mb-8 text-center font-medium"
          >
            {translate('order.openOrderLink')}
          </a>
        </div>
      </div>
    );
  }
};
